import { atomFamily } from "jotai/utils";
import { atom } from "jotai";
import { Edge } from "@xyflow/react";

import { edgesAtom } from ".";

export const hasSourceNodeAtomFamily = atomFamily((nodeId: string) => {
  const hasSourceNodeAtom = atom((get) => {
    const edges = get(edgesAtom);
    return hasSourceNode(edges, nodeId);
  });
  hasSourceNodeAtom.debugLabel = `hasSourceNodeAtomFamily(${nodeId})`;
  return hasSourceNodeAtom;
});

export default function hasSourceNode(edges: Edge[], nodeId: string) {
  const nonZapStepEdges = edges.filter((edge) => edge.type !== "zapStepEdge");
  return Boolean(nonZapStepEdges.find((edge) => edge.target === nodeId));
}
